export enum CETAClassroomStage {
  CETAKickoff = 'Beginning of the Year CETA',
  Planning = 'Planning',
  InvitationDeclined = 'Invitation Declined',
  ProgressMonitoring = 'Progress Monitoring',
  CETAUpdateRequired = 'End of the Year CETA Required',
  CETAUpdateCompleted = 'End of the Year CETA Completed',
  Continued = 'Continued',
  Archived = 'Archived'
}
